import React from "react";

/** Round table drawn as a ring of seats: filled = taken, hollow = free. */
export const SeatRing = ({ capacity = 10, used = 0, size = 110, conflict = false, label }) => {
  const cap = Number(capacity) || 0;
  const taken = Number(used) || 0;
  const seats = Math.max(cap, taken, 1);
  const radius = size / 2;
  const ring = radius - 11;
  const dots = Array.from({ length: seats }, (_, index) => {
    const angle = (index / seats) * Math.PI * 2 - Math.PI / 2;
    return {
      cx: radius + Math.cos(angle) * ring,
      cy: radius + Math.sin(angle) * ring,
      taken: index < taken,
      over: index >= cap,
    };
  });

  return (
    <div
      className="relative"
      style={{ width: size, height: size }}
      data-testid="seat-ring"
      role="img"
      aria-label={`${taken} of ${cap} seats taken`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle
          cx={radius}
          cy={radius}
          r={ring - 10}
          fill={conflict ? "#fff6f5" : "#fffdf9"}
          stroke={conflict ? "#b42318" : "#e7d7c3"}
          strokeWidth={1.2}
        />
        {dots.map((dot, index) => (
          <circle
            key={index}
            cx={dot.cx}
            cy={dot.cy}
            r={4.4}
            fill={dot.over ? "#b42318" : dot.taken ? "#7e9b8b" : "#ffffff"}
            stroke={dot.over ? "#b42318" : dot.taken ? "#5f7f70" : "#e6ded3"}
            strokeWidth={1.1}
          />
        ))}
      </svg>
      <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
        <span
          className="font-num text-[15px] font-semibold leading-none"
          style={{ color: conflict ? "var(--danger)" : "var(--ink)" }}
        >
          {taken}/{cap}
        </span>
        <span
          className="mt-1 text-[8px] font-semibold uppercase leading-none tracking-[0.16em]"
          style={{ color: "var(--muted-ink)" }}
        >
          {label || "seats"}
        </span>
      </div>
    </div>
  );
};

export default SeatRing;
